import { useTranslation } from 'react-i18next';
import { FilterSelect } from './FilterSelect';
import type { UseBooking } from '../booking/useBooking';

interface BookingFiltersProps {
  booking: UseBooking;
}

/** The five cascading, auto-filtering dropdowns (Oraș → Locație → Specialitate → Serviciu → Medic). */
export function BookingFilters({ booking }: BookingFiltersProps) {
  const { t } = useTranslation();
  const { selection, filterData, selectField, clearField, reset } = booking;

  const hasAny =
    selection.city || selection.location || selection.specialty || selection.service || selection.doctor;

  return (
    <div className="flex flex-col gap-4">
      <FilterSelect
        label={t('booking.city')}
        placeholder={t('booking.city_placeholder')}
        value={selection.city}
        options={filterData.cities}
        onChange={(o) => o && selectField('city', o)}
        onClear={() => clearField('city')}
      />
      <FilterSelect
        label={t('booking.location')}
        placeholder={t('booking.location_placeholder')}
        value={selection.location}
        options={filterData.locations}
        onChange={(o) => o && selectField('location', o)}
        onClear={() => clearField('location')}
      />
      <FilterSelect
        label={t('booking.specialty')}
        placeholder={t('booking.specialty_placeholder')}
        value={selection.specialty}
        options={filterData.specialties}
        onChange={(o) => o && selectField('specialty', o)}
        onClear={() => clearField('specialty')}
      />
      <FilterSelect
        label={t('booking.service')}
        placeholder={t('booking.service_placeholder')}
        value={selection.service}
        options={filterData.services}
        onChange={(o) => o && selectField('service', o)}
        onClear={() => clearField('service')}
      />
      <FilterSelect
        label={t('booking.doctor')}
        placeholder={t('booking.doctor_placeholder')}
        value={selection.doctor}
        options={filterData.doctors}
        onChange={(o) => o && selectField('doctor', o)}
        onClear={() => clearField('doctor')}
      />

      {hasAny && (
        <button
          type="button"
          onClick={reset}
          className="self-start text-sm font-semibold text-primary hover:underline"
        >
          {t('booking.restart')}
        </button>
      )}
    </div>
  );
}
